import { c as _c } from "react/compiler-runtime";
import { HotelCardSkeletonPropertiesType } from "@website/accommodation-ui/hotel-pagination/hotel-card-skeleton/hotel-card-skeleton.types";
import { Skeleton } from "@website/ui/skeleton";
import range from "lodash-es/range";
import { FC } from "react";
const HotelCardSkeletonDivider: FC<HotelCardSkeletonPropertiesType> = t0 => {
  const $ = _c(2);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "responsive" : t1;
  const t2 = size === "small" ? "bg-outline-thin h-px w-full" : "bg-outline-thin h-px w-full lg:h-full lg:w-px";
  let t3;
  if ($[0] !== t2) {
    t3 = <div className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  return t3;
};
export const HotelCardSkeleton: FC<HotelCardSkeletonPropertiesType> = t0 => {
  const $ = _c(42);
  const {
    size
  } = t0;
  const t1 = size === "small" ? "bg-on-color-high-emphasis flex w-full flex-col overflow-hidden rounded-xl" : "bg-on-color-high-emphasis flex w-full flex-col overflow-hidden rounded-xl lg:min-h-[234px] lg:flex-row";
  const t2 = size === "small" ? "flex h-[160px] shrink-0" : "flex h-[160px] shrink-0 lg:h-auto lg:w-[220px] xl:w-[312px]";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Skeleton shape="rectangle" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = size === "small" ? "flex h-full flex-col" : "flex h-full flex-col lg:flex-row";
  const t6 = size === "small" ? "flex min-w-0 shrink grow flex-col gap-3 px-4 py-3" : "flex min-w-0 shrink grow flex-col gap-3 px-4 py-3 lg:py-4";
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-4 w-full max-w-[262px]"><Skeleton shape="rectangle" /></div>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex h-4 gap-1">{range(5).map(_temp)}</div>;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="h-4 w-full max-w-[144px]"><Skeleton shape="rectangle" /></div>;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="h-4 w-full max-w-[216px]"><Skeleton shape="rectangle" /></div>;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="h-4 w-full max-w-[64px]"><Skeleton shape="rectangle" /></div>;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== t6) {
    t12 = <div className={t6}>{t7}{t8}{t9}{t10}{t11}</div>;
    $[8] = t6;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== size) {
    t13 = <HotelCardSkeletonDivider size={size} />;
    $[10] = size;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  const t14 = size === "small" ? "flex h-[64px] shrink-0 flex-row items-center justify-between gap-6 px-4 py-2" : "flex h-[64px] shrink-0 flex-row items-center justify-between gap-6 px-4 py-2 lg:h-full lg:min-w-[176px] lg:flex-col lg:items-center lg:justify-end lg:py-4";
  const t15 = size === "small" ? "flex grow flex-col gap-1" : "flex grow flex-col gap-1 lg:w-full lg:grow-0 lg:items-center lg:gap-2";
  let t16;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="h-3 w-[80px]"><Skeleton shape="rectangle" /></div>;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="h-4 w-full"><Skeleton shape="rectangle" /></div>;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  let t18;
  if ($[14] !== t15) {
    t18 = <div className={t15}>{t16}{t17}</div>;
    $[14] = t15;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  const t19 = size === "small" ? "h-8 w-[89px]" : "h-8 w-[89px] lg:h-6";
  let t20;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Skeleton shape="rectangle" />;
    $[16] = t20;
  } else {
    t20 = $[16];
  }
  let t21;
  if ($[17] !== t19) {
    t21 = <div className={t19}>{t20}</div>;
    $[17] = t19;
    $[18] = t21;
  } else {
    t21 = $[18];
  }
  const t22 = size === "small" ? "h-8 w-[33px]" : "h-8 w-[33px] lg:h-6";
  let t23;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Skeleton shape="rectangle" />;
    $[19] = t23;
  } else {
    t23 = $[19];
  }
  let t24;
  if ($[20] !== t22) {
    t24 = <div className={t22}>{t23}</div>;
    $[20] = t22;
    $[21] = t24;
  } else {
    t24 = $[21];
  }
  let t25;
  if ($[22] !== t21 || $[23] !== t24) {
    t25 = <div className="flex justify-center gap-1">{t21}{t24}</div>;
    $[22] = t21;
    $[23] = t24;
    $[24] = t25;
  } else {
    t25 = $[24];
  }
  const t26 = size === "small" ? "hidden h-9 w-full" : "hidden h-9 w-full lg:block";
  let t27;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Skeleton shape="rectangle" />;
    $[25] = t27;
  } else {
    t27 = $[25];
  }
  let t28;
  if ($[26] !== t26) {
    t28 = <div className={t26}>{t27}</div>;
    $[26] = t26;
    $[27] = t28;
  } else {
    t28 = $[27];
  }
  let t29;
  if ($[28] !== t14 || $[29] !== t18 || $[30] !== t25 || $[31] !== t28) {
    t29 = <div className={t14}>{t18}{t25}{t28}</div>;
    $[28] = t14;
    $[29] = t18;
    $[30] = t25;
    $[31] = t28;
    $[32] = t29;
  } else {
    t29 = $[32];
  }
  let t30;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t29 || $[36] !== t5) {
    t30 = <div className="flex min-w-0 shrink grow flex-col"><div className={t5}>{t12}{t13}{t29}</div></div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t29;
    $[36] = t5;
    $[37] = t30;
  } else {
    t30 = $[37];
  }
  let t31;
  if ($[38] !== t1 || $[39] !== t30 || $[40] !== t4) {
    t31 = <div className={t1}>{t4}{t30}</div>;
    $[38] = t1;
    $[39] = t30;
    $[40] = t4;
    $[41] = t31;
  } else {
    t31 = $[41];
  }
  return t31;
};
function _temp(indexKey) {
  return <div className="size-3" key={indexKey}><Skeleton shape="circle" height={12} /></div>;
}